/**
 * @generated SignedSource<<5ff989473f046a9b40e93f3c4d80b1bf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftItemTile_nftAuction$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ItemInternalContext_nftAuction" | "NftItemTileContent_nftAuction">;
  readonly " $fragmentType": "NftItemTile_nftAuction";
};
export type NftItemTile_nftAuction$key = {
  readonly " $data"?: NftItemTile_nftAuction$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftItemTile_nftAuction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftItemTile_nftAuction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftItemTileContent_nftAuction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ItemInternalContext_nftAuction"
    }
  ],
  "type": "NftAuction",
  "abstractKey": null
};

(node as any).hash = "08043aa594dfc5e3ee4450aae4c102e4";

export default node;
